import { Suspense, lazy } from "react";

import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco, Externo } from "./util";

// A ocorrência mais antiga carrega sob demanda: a primeira carga do card cabe no orçamento do
// ADR 0010. Enquanto isso, o fallback já traz o texto e a ressalva.
const OrigemWeb = lazy(() => import("./OrigemWeb"));

export function DeOndeVeio({ vista }: { vista: VistaCard }) {
  const p = vista.procedencia;
  const o = p.web_origin;
  return (
    <Bloco numero={1} titulo="De onde veio">
      {p.encontrada ? (
        <ul>
          {p.veiculo && <li>Veículo: {p.veiculo}</li>}
          {p.autor && <li>Autor: {p.autor}</li>}
          {p.data && <li>Data: {p.data}</li>}
          {p.contexto && <li>Contexto: {p.contexto}</li>}
          {p.url && (
            <li>
              <Externo href={p.url}>Página de origem</Externo>
            </li>
          )}
        </ul>
      ) : (
        <>
          <p>Não encontramos a origem desta afirmação.</p>
          {p.citada_na_mensagem && (
            <ul>
              <li>Origem citada na mensagem: {p.citada_na_mensagem}</li>
            </ul>
          )}
        </>
      )}
      {o && (
        <Suspense
          fallback={
            <p>
              {o.texto} {o.ressalva}
            </p>
          }
        >
          <OrigemWeb origem={o} />
        </Suspense>
      )}
      {vista.nao_analisadas.length > 0 && (
        <>
          <p>Outras afirmações do mesmo texto, não analisadas neste card:</p>
          <ul>
            {vista.nao_analisadas.map((n) => (
              <li key={n.forma_neutra}>
                {n.forma_neutra} <span className={estilos.fonte}>({n.motivo})</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </Bloco>
  );
}
